// extracted by mini-css-extract-plugin
export default {"contextMenu":"contextMenu_contextMenu__YLeV-","contextMenuItem":"contextMenu_contextMenuItem__GoGNo"};